export default "__VITE_ASSET__C3x0qrhb__"